import { render, staticRenderFns } from "./VueAnchorRouterLink.vue?vue&type=template&id=22a88fbf&"
import script from "./VueAnchorRouterLink.vue?vue&type=script&lang=js&"
export * from "./VueAnchorRouterLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports